var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"cg_toast regular"},[_c('div',{staticClass:"toast-content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}})])]):_vm._e()])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }